import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShowdoctorComponent } from '../showdoctor/showdoctor.component';
import { ShowhospitalComponent } from '../showhospital/showhospital.component';
import { AppoinmentserviceService } from '../add-appoinments/appoinmentservice.service';
import { Notification } from '../../../core/Notifications/Notification';
import { Router } from '@angular/router';
import { DialogContentExample1Component } from '../dialog-content-example1/dialog-content-example1.component';

@Component({
  selector: 'app-dialogdoctor',
  templateUrl: './dialogdoctor.component.html',
  styleUrls: ['./dialogdoctor.component.scss']
})
export class DialogdoctorComponent implements OnInit {
  test: any;
  doctordd: any;
  enable=true;
  enables=true;
  clinicalshow:boolean;
  hospitalshow:boolean;
  selected_doctor = 0;
  selected_hospital = 0;
  selected_hospital_doctor = 0;
  data: any;
  isDisabled=true;
  hospitaldd: any;
  testhosid: any;
  userData: any;
  photo: any;
  Sp_Id: number = 0;
  constructor(@Inject(MAT_DIALOG_DATA) private _data: any,public dialog: MatDialog,private AppoinmentserviceService: AppoinmentserviceService,
  private notify: Notification,private router: Router,) { 
    
  }



  ngOnInit(): void {
    console.log('data', this._data)
    //this.get_doctordd();
    this.Get_Userprofile();
    this.Get_specialization();
  }


  showdoctr() {
    this.selected_hospital_doctor = 0;
    this.selected_hospital = 0; // Reset selected hospital
    this.doctordd = [];
    this.enable=false;
    this.enables = true;
    // this.GetDoctorList_BasedonSchedule();
    
  }
  
  showhosptl() {
    this.enable=true;
    this.enables = false;
    this.get_hospitaldd();
    this.selected_doctor = 0; // Reset selected doctor
    this.doctordd = [];
    // this.hospitalshow=true;
    // const dialogRef = this.dialog.open(ShowhospitalComponent,
    //   {
    //     height: '65%',
    //     width: '65%',
    //   });

    // dialogRef.afterClosed().subscribe(result => {
    //   console.log(`Dialog result: ${result}`);
    //   // if (result != undefined) {
    //   //   this.test = result.dO_Name;
    //   //   this.appoinmentForm.controls['Appt_DO_Id_FK'].setValue(result.dO_Id);
    //   // }
    //   //   setTimeout(() => {
    //   //     window.location.reload();
    //   // }, 2000);
    // });
  }
  // DoctorDD(data) {
  //   console.log(data)
  //   this.testhosid = data
  //   this.get_doctordd(data);
  //   // this.GetDoctorList_BasedonSchedule();
  // }

  get_doctordd(HospitalId) {
    this.AppoinmentserviceService.get_doctorbyhospitalId(HospitalId)
      .subscribe((data) => {
        this.doctordd = data
        console.log(this.doctordd)
      })
  }

  GetDoctorList_BasedonSchedule(HospitalId: number, SpecializationId: number) {
    console.log('Test', this.testhosid);
    this.AppoinmentserviceService.GetDoctorList_BasedonSchedule(this._data.select_day, this._data.select_FrmTime, this._data.select_toTime,SpecializationId,HospitalId)
      .subscribe((data) => {
        this.doctordd = data
        console.log(this.doctordd)
      })
  }

  onSpecializationChange(SpecializationId: number) {
    if (this.selected_hospital !== 0) {
      this.GetDoctorList_BasedonSchedule(this.selected_hospital, SpecializationId);
    }
    this.selected_hospital_doctor=null;
    this.doctordd = [];
  }

  Get_Userprofile(){
    this.AppoinmentserviceService.Get_Userprofile()
      .subscribe((data) => {
        this.userData = data
      })
  }
  special: any;
  Get_specialization() {
    this.AppoinmentserviceService.Get_specialization()
      .subscribe((data) => {
        this.special = data
      })
  }

  onHospitalChange(){
    this.Sp_Id = null;
    this.selected_hospital_doctor=null;
    this.doctordd = [];
  }

  saveForm() {
    if (this.selected_doctor == 0 && this.selected_hospital == 0 && this.selected_hospital_doctor == 0) {
      // If both doctor and hospital are not selected, show an error message
      this.notify.errorsmsg("Please select Clinic Doctor or Hospital.");
      return;
  }  
  
  // if (this.selected_hospital_doctor !== 0) {
  //   this._data.Appt_DO_Id_FK = this.selected_hospital_doctor;
  // } else {
  //   this._data.Appt_DO_Id_FK = this.selected_doctor;
  // }
  this._data.Appt_DO_Id_FK = this.selected_hospital_doctor;
  this._data.Appt_Hos_Id_FK = this.selected_hospital;
  // this._data.Sp_Id = this.Sp_Id;  
  
  console.log('appointment data :', this._data);
  this.AppoinmentserviceService.Post_appoinment(this._data)
      .subscribe(
          (data: any) => {
              this._data = data;
              this.get_patientlogo(this.userData.Id)
              this.openDialog();
              console.log("xxyyxxx:",this.userData.Id);
              this.router.navigate(["/base/patient/Appoinment"]);
              this.notify.successmsg("Appointment fixed Successfully.");
              
          },
          (error: any) => {
              this.notify.errorsmsg("An error occurred while fixing the appointment.");
              console.error(error);
          }
      );
  }

  openDialog() {
    const dialogRef = this.dialog.open(DialogContentExample1Component);
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      window.location.reload();
      window.location.reload();
    });
  }
  
  get_hospitaldd() {
    this.AppoinmentserviceService.Get_HospitalDD()
      .subscribe((data) => {
        this.hospitaldd = data
      })
  }
  get_patientlogo(data:any){
    this.AppoinmentserviceService.get_patientlogo(data)
      .subscribe((data) => {
        this.photo = data
      })
  }


}
